import { creatorbase } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import { CellContext } from '@tanstack/react-table';
import { ProjectTableMeta } from '../../../../Project/components/types';

export type ProjectSelectTableRow = creatorbase.Project & {
    brand: creatorbase.Brand | null;
    team: creatorbase.Team | null;
    users: creatorbase.User[];
};

export type Meta = ProjectTableMeta<ProjectSelectTableRow> & {
    isLoading?: boolean;
    isFetchingNextPage?: boolean;
    hasError?: boolean;
};

export type TableCellContext<TKey extends keyof ProjectSelectTableRow> = CellContext<
    ProjectSelectTableRow,
    ProjectSelectTableRow[TKey]
>;

export const getTableMeta = getTableMetaHelper<Meta>();
export const resolveRowId = (row: ProjectSelectTableRow | {}) =>
    'id' in row && typeof row.id === 'number' ? row.id : null;
